import React from "react";
import type { LogoProps } from "../../content/component-header";
import { useLocalizedUrl } from "../../hooks/useLocalizedUrl";
import { Logo } from "../ui";
import { Link } from "react-router-dom";

type Props = {
    logo?: LogoProps;
    onClick?: () => void;
};

export const HeaderLogo: React.FC<Props> = ({ logo, onClick }) => {
    const homeUrl = useLocalizedUrl("/");

    if (logo) {
        return (
            <Link
                to={logo.href ?? homeUrl}
                className="flex-shrink-0 flex flex-row h-12"
                aria-label="Go to homepage"
                onClick={onClick}
            >
                <img src={logo.image} alt="Vertriebsportal" />
                {logo.title && (
                    <div className="ml-4">
                        <div className="text-neutral-50 font-bold">{logo.title}</div>
                        {logo.subtitle && <div className="text-accent text-sm">{logo.subtitle}</div>}
                    </div>
                )}
            </Link>
        );
    }

    return (
        <a href={homeUrl} className="flex-shrink-0" aria-label="Go to homepage" onClick={onClick}>
            <Logo variant="dark" />
        </a>
    );
};
